import FJTextStyleManager from './FJTextStyleManager';
import FJBase from './style/FJBase';

class FJTextStyle {
    constructor(props) {
        props = props || {};
        this._type = typeof props.type != 'undefined' ? props.type : 'None';

        // 禁用样式只用普通样式
        this._enableStyle = false;

        this._baseStyle = new FJBase({
            ...props,
            offset: 0,
            angle: 0,
            position: 'relative',
        });

        this.initStyles(props);
    }

    get type() {
        return this._type;
    }

    set enableStyle(value) {
        this._enableStyle = value;
    }

    get enableStyle() {
        return this._enableStyle;
    }

    get styles() {
        return this._styles;
    }

    toJSON() {
        return {
            styles: this._styles.map(style => style.toJSON()),
            type: this._type,
        };
    }

    initStyles(props) {
        this._styles = [];
    }

    fromJSON(data) {
        this._type = data.type;
        this.initStyles(data);
        data.styles.forEach((style, index) => {
            if (style && this._styles[index]) {
                this._styles[index].fromJSON(style);
            }
        });
    }

    encode() {
        let styles = [];
        this._styles.forEach(style => {
            styles.push(style.encode());
        });

        return {
            styles: styles,
            type: this._type,
        };
    }
    decode(data) {
        this._type = data.type;
        this._styles.forEach((style, index) => {
            if (style && data.styles[index]) {
                style.decode(data.styles[index]);
            }
        });
    }
    clone() {
        let object = FJTextStyleManager.createStyle(FJTextStyleManager.TEXT_STYLES[this.type]);
        object.decode(this.encode(this));
        return object;
    }

    /**
     * @desc 获取所有style的文字元素标签
     * @return {*[]}
     */
    getAllTextLayers() {
        let layerList = [];
        this._styles.forEach(item => {
            let layers = item.getTextLayers();
            if (layers && layers.length > 0) {
                // 如果数据中的元素是数组，则需要分开添加到layerList中
                if (Array.isArray(layers[0])) {
                    layers.forEach(textLayer => {
                        layerList.push(textLayer);
                    });
                } else layerList.push(layers);
            }
        });
        return layerList;
    }

    /**
     * @description 得到需要进行设置的值
     * @returns {{color: [*], offset: *, direction: *}}
     */
    getAdjustInfo() {
        return {};
    }

    /**
     * @description 设置对应的属性值
     * @param info
     */
    setAdjustInfo(info) {}

    /**
     * 将style应用到
     * @param view
     * @param textData
     * @param options
     */
    addToView(view, textData, options) {
        if (!view) return;

        if (this._enableStyle) {
            this._baseStyle.addToView(view, textData, options);
            return;
        }

        this._styles.forEach(style => {
            style.addToView(view, textData, options);
        });
    }

    /**
     * 更新文字padding样式
     * @param padding
     */
    updatePadding(padding) {
        this._styles.forEach(style => {
            style.updatePadding(padding);
        });
    }

    /**
     * 更新文字样式
     * @param styleData
     */
    updateStyle(styleData) {
        if (this._enableStyle) {
            this._baseStyle.updateAllLineStyle(styleData);
            return;
        }

        this._styles.forEach(style => {
            // style.updateStyle(styleData, lineIdx);
            style.updateAllLineStyle(styleData);
        });
    }

    /**
     * 兼容Safari浏览器输出，shadow中的坐标系输出与预览是反的
     * 调用该方法临时将旋转角度取反，输出完成后需调用resetShadowAngleForSafari 重置数据
     */
    updateShadowAngleForSafari() {
        this._styles.forEach(style => {
            switch (style.name) {
                case 'FJShadow':
                case 'FJGlitch':
                    style.angle *= -1;
                    break;
            }
        });
    }

    /**
     * updateShadowAngleForSafari 方法调用后，输出完成后，需调用改方法重置数据
     */
    resetShadowAngleForSafari() {
        this._styles.forEach(style => {
            switch (style.name) {
                case 'FJShadow':
                case 'FJGlitch':
                    style.angle *= -1;
                    break;
            }
        });
    }

    /**
     * 清除Style的Dom渲染
     */
    clear() {
        this._styles.forEach(style => {
            style.clear();
        });
    }

    /**
     * @desc 获取实际的文字dom对象 <排除样式辅助>
     */
    getActualLayer() {
        if (this._enableStyle) {
            return this._baseStyle.getActualLayer();
        }

        if (!this._styles[0]) return null;

        return this._styles[0].getActualLayer();
    }
}

export default FJTextStyle;
